<template>
  <div class="pb-5 w-full relative">
    <!--
    <div v-if='enableCategories' class="fixed top-0 w-full flex flex-wrap flex-row justify-between bg-gray-100 shadow">
      <pbc-toggle-button v-for='group in groups' :key='group[0].name' class='text-lg p-2 mx-1 my-1'>
        {{group[0].name}}
      </pbc-toggle-button>
    </div>
    -->

    <div  :class='enableCategories?"":""'>
      <div v-for='group in groups'
           :key='group[0].name'
           class='bg-gray-400'
           :class='enableCategories ? "rounded-lg shadow-inner shadow-lg border-gray-600 mb-2 border-1" : ""'
           >
        <div v-if='enableCategories'
            :style='enableCategories ? {"color": group[0].color} : {}'
             class='text-sm font-semibold uppercase p-2 text-gray-600'>
          {{group[0].name}}
        </div>
        <div class='flex flex-col md:flex-row md:flex-wrap md:justify-around'>
          <div v-for='type in group[1]' :key='type.text' class="grow md:flex-none md:flex-wrap md:w-64 mx-1 md:mx-0">
            <component-link-or-transform-button :description="type.description"
                                                :text="type.text" 
                                                :icon="type.icon"
                                                :image='type.image'
                                                :type='type.type'
                                                @click='select'
                                                @next='$emit("next")'
                                                :show-done='showDone'
                                                :is-selected='isSelected(type)' />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sortBy, toPairs, groupBy } from 'lodash';
import ComponentLinkOrTransformButton from '@ui/molecules/ComponentLinkOrTransformButton.vue';
import PbcToggleButton from '@ui/atoms/PbcToggleButton.vue';

export default {
  inject: ['api'],
  props: {
    items: {
      type: Array,
      required: true
    },
    initialSelection: {
      type: String,
      default: ''
    },
    showDone: {
      type: Boolean,
      default: false
    },
    enableCategories: {
      type: Boolean,
      default: false
    },
    sortKeys: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    select(type) {
      if (type === this.selectedType) {
        this.$emit('next');
        return;
      }
      this.selectedType = type;
      this.$emit('select', type);
    },
    isSelected(type) {
      return this.selectedType === type.type;
    }
  },
  data() {
    return {
      selectedType: this.initialSelection
    }
  },
  components:{
    ComponentLinkOrTransformButton,
    //PbcToggleButton
  },
  computed: {
    groups() {
      const categories = {
        default: {
          name: 'Default',
          key: 'default',
          color: '#cecece'
        }
      };

      return sortBy(toPairs(groupBy(this.items, (type) => {
        if (this.enableCategories) {
          categories[type.category.name] = type.category;
          return type.category.name;
        } else {
          return 'default';
        }
      })), ([categoryName]) => {
        if (this.sortKeys[categoryName]) {
          return this.sortKeys[categoryName];
        } else {
          return categoryName;
        }
      }).map( ([categoryName,items]) => {
        const category = categories[categoryName];
        return [category, items];
      });
    }
  }
}
</script>
